import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import classNames from "classnames";
import "./modal.scss";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  withStyles,
} from "@material-ui/core";
import { hasDangerousCode } from "../../utils/utils";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#e5e5e5",
    color: "#212529",
    height: 3,
  },
  body: {
    fontSize: 14,
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
  },
  root: {
    padding: "15px",
  },
}))(TableCell);

export default function EditAllModal(props) {
  const [open, setOpen] = useState(props.openModel);
  const [inputData, setinputData] = useState({
    TRADE_TYPE_DESC: "",
    BANNER: "",
  });

  const handleClose = () => {
    setOpen(false);
    props.closeModel();
    setinputData({
      TRADE_TYPE_DESC: "",
      BANNER: "",
    });
  };

  const handleSave = () => {
    const Modified_Updated_Data = props.allRowData
      .filter((data) => data.isCheckedRow)
      .map((item) => {
        return {
          item_Id: item.item_Id,
          rowData: {
            ...item.rowData,
            TRADE_TYPE_DESC:
              inputData.TRADE_TYPE_DESC?.trim() !== ""
                ? inputData.TRADE_TYPE_DESC
                : item.rowData.TRADE_TYPE_DESC,
            BANNER:
              inputData.BANNER?.trim() !== ""
                ? inputData.BANNER.toUpperCase()
                : item.rowData.BANNER,
          },
        };
      });
    const Updated_Data = props.allRowData.map((item) => {
      if (item.isCheckedRow) {
        return {
          ...item,
          isCheckedRow: false,
          rowData: {
            ...item.rowData,
            TRADE_TYPE_DESC:
              inputData.TRADE_TYPE_DESC?.trim() !== ""
                ? inputData.TRADE_TYPE_DESC
                : item.rowData.TRADE_TYPE_DESC,
            BANNER:
              inputData.BANNER?.trim() !== ""
                ? inputData.BANNER
                : item.rowData.BANNER,
          },
        };
      }
      return item;
    });

    props.updateSourceInputs("current_mapped_data", Updated_Data);
    props.updateSourceInputs("modified_mapped_data", [
      ...(props.modified_mapped_data || []),
      ...Modified_Updated_Data,
    ]);
    props.updateSourceInputs("checked_rows_count", 0);
    props.setGlobalEdit(true);
    setOpen(false);
    props.closeModel();
  };

  const handleOnInputChange = (e, name) => {
    const ColumnValue = e?.target?.value || "";
    const DROPDOWN_DATA = props?.sourceData?.data?.dropdown || {};
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      props.updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    setinputData((prevData) => ({
      ...prevData,
      [name]: e.target.value,
    }));
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Multi Record Edit</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>
            <TableContainer>
              <Table>
                <TableHead className="table-heading">
                  <TableRow>
                    {props.edit_Model_Column_List
                      .filter(
                        (item) =>
                          item.label === "Trade Type" ||
                          item.label === "Banner",
                      )
                      .reverse()
                      .map((column, index) => (
                        <StyledTableCell
                          key={index}
                          style={{ fontSize: "16px" }}
                        >
                          {column.label}
                        </StyledTableCell>
                      ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  <TableRow>
                    {props.edit_Model_Column_List
                      .filter(
                        (item) =>
                          item.label === "Trade Type" ||
                          item.label === "Banner",
                      )
                      .reverse()
                      .map((column, index) => (
                        <StyledTableCell>
                          <input
                            type="text"
                            style={{
                              width: "100%",
                              // borderTop: "none",
                              // borderLeft: "none",
                              // borderRight: "none",
                              // borderBottom: "1px solid black",
                              outline: "none", // Optional: removes blue outline on focus
                            }}
                            onChange={(e) => {
                              handleOnInputChange(e, column.name);
                            }}
                            value={inputData[column.name] || ""}
                          />
                        </StyledTableCell>
                      ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginBottom: "5px" }}>
          <Button
            disableFocusRipple
            variant="outlined"
            style={props.cancelButtonStyle}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            disableFocusRipple
            style={props.SaveButtonStyle}
            onClick={handleSave}
          >
            <span>Apply to All</span>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
